/*Método: Notifications - Servicio de lectura del API: Maneja las notificaciones presentadas en el encabezado del sistema (campana)
  Tareas:
    GetSummarybyUser   //Lista de Notificaciones (pendientes y avisos)        //*Propuesta *
    SendEmail          //Envia correo al usuario cuando enviar propuesta      //*Propuesta *
    DeleteNoticebyUser //Elimina los avisos                                   //*Encabezado
*/

import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL + 'Notifications/';

  //se genera una función por cada tarea del recurso api
    
    //tarea: GetSummarybyUser 
    const cargaGetSummarybyUser = async (token:any) => {
        //console.log ('***API: ' + API_URL + 'GetSummarybyUser',  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'GetSummarybyUser', 'method: post',
           { headers: { 'content-type': 'text/json', 'Authorization':token }} )
    };

    /* //no la use, da un resultado erroneo, tomo valor de GetSummarybyUser
     //tarea: GetCountbyUser 
     const cargaGetCountbyUser = async (token:any) => {
      console.log ('***API: ' + API_URL + 'GetCountbyUser',  {headers: { 'content-type': 'text/json' }} )
      return await axios.post(API_URL + 'GetCountbyUser', 'method: post',
         { headers: { 'content-type': 'text/json', 'Authorization':token }} )
    }; */

    //tarea: DeleteNoticebyUser 
    const cargaDeleteNoticebyUser = async (token:any, body:any) => {
      //console.log ('***API: ' + API_URL + 'DeleteNoticebyUser',  {headers: { 'content-type': 'text/json' }} )
      return await axios.post(API_URL + 'DeleteNoticebyUser', body,
        { headers: { 'content-type': 'text/json', 'Authorization':token }} )
    };

    //tarea: SendEmail 
    const cargaSendEmail =  (token:any, body:any) => {
      console.log ('***API: ' + API_URL + 'SendEmail',  {headers: { 'content-type': 'text/json' }} )
      return  axios.post(API_URL + 'SendEmail', body,
        { headers: { 'content-type': 'text/json', 'Authorization':token }} )
    };

  const notificationsService = {
      cargaGetSummarybyUser: cargaGetSummarybyUser,
      //cargaGetCountbyUser: cargaGetCountbyUser,
      cargaDeleteNoticebyUser: cargaDeleteNoticebyUser,
      cargaSendEmail: cargaSendEmail
  };

export default notificationsService;
